import { WorkItemTypes } from 'common/workitems/constants/workitem-types';

export class LiveWorkloadTabHelper {
  public static getIconByWorkItemType(workItemType: WorkItemTypes): string {
    switch (workItemType) {
      case WorkItemTypes.CHAT:
        return 'chat-large';
      case WorkItemTypes.EMAIL:
        return 'mail';
      case WorkItemTypes.SMS:
        return 'sms';
      case WorkItemTypes.FACEBOOK:
        return 'message';
      case WorkItemTypes.ASYNC_MESSAGE:
        return 'async-message';
      case WorkItemTypes.OMNI:
        return 'person-filled';
      default:
        return '';
    }
  }

  public static getTooltip(workloadType, workItemType: WorkItemTypes): string {
    const workload = workloadType === 'agentWorkload' ? 'agentListTab' : 'departmentListTab';
    switch (workItemType) {
      case WorkItemTypes.CHAT:
        return workload + '.headers.chat';
      case WorkItemTypes.EMAIL:
        return workload + '.headers.email';
      case WorkItemTypes.SMS:
        return workload + '.headers.sms';
      case WorkItemTypes.FACEBOOK:
        return workload + '.headers.facebook';
      case WorkItemTypes.ASYNC_MESSAGE:
        return workload + '.headers.asyncMessage';
      default:
        return '';
    }
  }
}
